var render = function render(){var _vm=this,_c=_vm._self._c;return _c('hr',{staticClass:"divider",class:_vm.size,style:(_vm.styles)})
}
var staticRenderFns = []

export { render, staticRenderFns }